// removed by extract-text-webpack-plugin
module.exports = {"root":"reel__root--21Avo","active":"reel__active--3fVeR","bar":"reel__bar--3DVSH","titleWrapper":"reel__titleWrapper--2pK3F","title":"reel__title--1ulpw mainTitleText","video":"reel__video--3CxMO","bgvideoWrapper":"reel__bgvideoWrapper--2eUwZ","bgvideo":"reel__bgvideo--xUVqQ","bgvideoMobile":"reel__bgvideoMobile--8sV-6 reel__bgvideo--xUVqQ","bgvideoDesktop":"reel__bgvideoDesktop--2Wa1d reel__bgvideo--xUVqQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Reel/reel.css
// module id = 0RGi
// module chunks = 0